module.exports = __webpack_public_path__ + "assets/images/2d7cafbf25c5fb6ec99a6133d7b81d04.svg";